import AsyncStorage from '@react-native-async-storage/async-storage'
import { getApp, getApps, initializeApp } from 'firebase/app'
import {
    connectAuthEmulator,
    getAuth,
    getReactNativePersistence,
    initializeAuth,
} from 'firebase/auth/react-native'
import { connectDatabaseEmulator, getDatabase } from 'firebase/database'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import Config from 'react-native-config'
import { firebaseConfig } from './src/constants/firebase'
import { isDetox } from './src/constants/platform'

if (!getApps().length) {
    const app = initializeApp(firebaseConfig)
    initializeAuth(app, {
        persistence: getReactNativePersistence(AsyncStorage),
    })
}

if (isDetox) {
    const auth = getAuth()
    connectAuthEmulator(auth, `http://${Config.HOST}:${Config.FIREBASE_AUTH_EMULATOR_PORT}`)

    const functions = getFunctions(getApp())
    connectFunctionsEmulator(functions, Config.HOST!, +Config.FIREBASE_FUNCTIONS_EMULATOR_PORT)

    const db = getDatabase()
    connectDatabaseEmulator(db, Config.HOST!, +Config.FIREBASE_DATABASE_EMULATOR_PORT)
}
